/**
 * When interacting with zero values,
 *
 * rounding used to ensure that we never tkae to much vertical space
 */
export default function BarLabelWithNullZeros({
  x,
  y,
  width,
  height,
  value,
}: {
  x: number;
  y: number;
  width: number;
  height: number;
  value: number;
}) {
  const extraSpaceForText = 5;
  return (
    <g>
      <text x={x + width / 2} y={y - extraSpaceForText} textAnchor="middle">
        {value !== 0 ? Math.round(value * 100) / 100 : null}
      </text>
    </g>
  );
}
